"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var builder_1 = require("../builder");
var AnimationService = (function () {
    function AnimationService() {
    }
    AnimationService.prototype.builder = function () {
        return new builder_1.AnimationBuilder();
    };
    AnimationService = __decorate([
        core_1.Injectable()
    ], AnimationService);
    return AnimationService;
}());
exports.AnimationService = AnimationService;



//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/css-animator/angular/animation.service.js
// module id = ../../../../css-animator/angular/animation.service.js
// module chunks = vendor